module.exports = __webpack_public_path__ + "img/arow_up.e873ccee.svg";